/**
 * EyeCaptain's own social profiles. One list for the footer and the Organization schema (sameAs).
 * Check each URL is ours before adding it: facebook.com/eyecaptain, instagram.com/eyecaptain,
 * tiktok.com/@eyecaptain and x.com/eyecaptain belong to other people.
 */
export const SOCIAL_PROFILES = {
  linkedin: 'https://www.linkedin.com/company/eyecaptain',
  facebook: 'https://www.facebook.com/profile.php?id=61590451917591',
  instagram: 'https://www.instagram.com/eyecaptain.io',
  tiktok: 'https://www.tiktok.com/@eyecaptain.io',
} as const;

export const SOCIAL_URLS: string[] = Object.values(SOCIAL_PROFILES);
